// -----------------------------------
// globalUtils.js
// Helpers and Buggyfills
// -----------------------------------

import viewportUnitsBuggyfill from 'viewport-units-buggyfill';
import 'lazysizes';

export const globalUtils = {
  init() {
    // Remove no-js class
    document.querySelector('html').classList.remove('no-js');

    // Viewport Units Buggyfill
    // https://www.npmjs.com/package/viewport-units-buggyfill
    viewportUnitsBuggyfill.init({ refreshDebounceWait: 250 });

    // LazySizes inits automatically:
    // https://github.com/aFarkas/lazysizes
    window.lazySizesConfig = window.lazySizesConfig || {};

    // Lazy Loading
  }
};
